export const  PRODUCT_REQUEST="PRODUCT_REQUEST";  

export const GET_PRODUCT_SUCCESS="GET_PRODUCT_SUCCESS";  
//
export const ADD_PRODUCT_SUCCESS="ADD_PRODUCT_SUCCESS";  

export const 
DELETE_PRODUCT_SUCCESS="DELETE_PRODUCT_SUCCESS";  

export const 
PATCH_PRODUCT_SUCCESS="PATCH_PRODUCT_SUCCESS";  


export const PRODUCT_FAILURE="PRODUCT_FAILURE";  
 